import {
  // CONTRATO_CAMPOS_DOS_GOYTACAZES,
  // CONTRATO_DETRAN_ES,
  // CONTRATO_DETRO,
  // CONTRATO_LEILAO,
  // CONTRATO_POLICIA_CIVIL,
  // CONTRATO_PREFEITURA,
  CONTRATO_IMTT_CAMPOS_DOS_GOYTACAZES,
  CONTRATO_POSTURA_CAMPOS_DOS_GOYTACAZES,
  CONTRATO_GM_CAMPOS_DOS_GOYTACAZES
} from './configuracoes-contratos/configuracoes-contratos'

export default [
  // {
  //   acl: 'relatorio_gerenciais_detro',
  //   label: 'DETRO',
  //   value: CONTRATO_DETRO,
  //   icon: 'fa fa-file-text-o'
  // },
  // {
  //   acl: 'relatorio_gerenciais_policia_civil',
  //   label: 'Polícia Civil',
  //   value: CONTRATO_POLICIA_CIVIL,
  //   icon: 'icon-shield icon'
  // },
  // {
  //   acl: 'relatorio_gerenciais_detranES',
  //   label: 'DETRAN/ES',
  //   value: CONTRATO_DETRAN_ES,
  //   icon: 'fa fa-file-text-o'
  // },
  // {
  //   acl: 'relatorio_gerenciais_prefeitura',
  //   label: 'Prefeitura Barra do Piraí',
  //   value: CONTRATO_PREFEITURA,
  //   icon: 'fa fa-file-text-o'
  // },
  // {
  //   acl: 'relatorio_gerenciais_campos_goytacazes',
  //   label: 'Campos dos Goytacazes',
  //   value: CONTRATO_CAMPOS_DOS_GOYTACAZES,
  //   icon: 'fa fa-file-text-o'
  // },
  // {
  //   acl: 'relatorio_gerenciais_leilao',
  //   label: 'Leilão',
  //   value: CONTRATO_LEILAO,
  //   color: 'btn-primary',
  //   icon: 'fa fa-gavel'
  // },
  {
    acl: 'relatorio_gerenciais_gm_campos_goytacazes',
    label: 'Guarda Municipal Campos dos Goytacazes',
    value: CONTRATO_GM_CAMPOS_DOS_GOYTACAZES,
    icon: 'icon-shield icon'
  },
  {
    acl: 'relatorio_gerenciais_postura_campos_goytacazes',
    label: 'Postura Campos dos Goytacazes',
    value: CONTRATO_POSTURA_CAMPOS_DOS_GOYTACAZES,
    icon: 'fa fa-file-text-o'
  },
  {
    acl: 'relatorio_gerenciais_imtt_campos_goytacazes',
    label: 'IMTT Campos dos Goytacazes',
    value: CONTRATO_IMTT_CAMPOS_DOS_GOYTACAZES,
    icon: 'fa fa-file-text-o'
  }
]



// WEBPACK FOOTER //
// ./src/app/website/relatorios-gerenciais/menu-relatorios.js